export default __webpack_public_path__ + "static/media/2309e506d38522d6.26559ac4b3fa253f563c85b7424c2615.svg";